import {SedestralRouter} from "../SedestralRouter";
import {StaticComponent} from "./component/StaticComponent";
import {LoaderStatic} from "../../../products/panel/components/static/loaders/LoaderStatic";
import {NotificationsStatic} from "../../../products/panel/components/static/notifications/NotificationsStatic";
import {HelpCenterStatic} from "../../../products/panel/components/static/helpcenter/HelpCenterStatic";
import {SlidingLoaderStatic} from "../../../products/panel/components/static/loaders/sliding/SlidingLoaderStatic";
import {PageLoaderStatic} from "../../../products/panel/components/static/loaders/page/PageLoaderStatic";
import {
    MobileNavigationStatic
} from "../../../products/panel/components/static/navigation/mobile/MobileNavigationStatic";
import {TwoFactorStatic} from "../../../products/panel/components/static/twofactor/TwoFactorStatic";

export class SedestralStaticRouter {

    public components: {
        loader?: LoaderStatic,
        pageLoader?: PageLoaderStatic,
        slidingLoader?: SlidingLoaderStatic,
        notifications?: NotificationsStatic,
        helpCenter?: HelpCenterStatic,
        navigation?: MobileNavigationStatic,
        twoFactor?: TwoFactorStatic
    };

    constructor(router: SedestralRouter) {
        this.components = {};
    }

    register(name: string, component: StaticComponent) {
        this.components[name] = component;
    }

    onHash(): void {
        for (let key in this.components) {
            if (this.components.hasOwnProperty(key)) {
                let component = this.components[key];
                component.onHash();
            }
        }
    }
}